var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtKiwi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 448,
    viewBox: "0 0 624 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 32,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 32,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 32,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 288,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 288,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 288,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 288,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 288,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 128,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 64,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 96,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 160,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtKiwi);
export default __webpack_public_path__ + "static/media/pixel-art-kiwi.253f0ca484dea5dda6642f8d0cd4428c.svg";
export { ForwardRef as ReactComponent };